var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2149_2242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2149_2242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.73138V3.0625C5.25 2.94647 5.20391 2.83519 5.12186 2.75314C5.03982 2.67109 4.92854 2.625 4.8125 2.625C4.69647 2.625 4.58519 2.67109 4.50314 2.75314C4.4211 2.83519 4.375 2.94647 4.375 3.0625V8.3125C4.375 8.42853 4.4211 8.53981 4.50314 8.62186C4.58519 8.70391 4.69647 8.75 4.8125 8.75H10.0625C10.1785 8.75 10.2898 8.70391 10.3719 8.62186C10.4539 8.53981 10.5 8.42853 10.5 8.3125C10.5 8.19647 10.4539 8.08519 10.3719 8.00314C10.2898 7.92109 10.1785 7.875 10.0625 7.875H5.4705C7.37625 5.2255 10.4869 3.5 14 3.5C19.7986 3.5 24.5 8.20138 24.5 14C24.5 19.7986 19.7986 24.5 14 24.5C8.20138 24.5 3.5 19.7986 3.5 14C3.5 13.58 3.52421 13.1661 3.57263 12.7584C3.58064 12.6954 3.57526 12.6314 3.55685 12.5706C3.53844 12.5098 3.50741 12.4536 3.46579 12.4056C3.42417 12.3576 3.37289 12.319 3.31531 12.2921C3.25773 12.2653 3.19514 12.251 3.13163 12.25C3.02811 12.2491 2.92786 12.2862 2.84982 12.3543C2.77179 12.4223 2.72139 12.5166 2.70813 12.6193C2.65244 13.0774 2.62468 13.5385 2.625 14C2.625 20.2825 7.7175 25.375 14 25.375C20.2825 25.375 25.375 20.2825 25.375 14C25.375 7.7175 20.2825 2.625 14 2.625C10.4825 2.625 7.33688 4.22187 5.25 6.73138ZM13.5625 7C13.6785 7 13.7898 7.04609 13.8719 7.12814C13.9539 7.21019 14 7.32147 14 7.4375V14H18.8125C18.9285 14 19.0398 14.0461 19.1219 14.1281C19.2039 14.2102 19.25 14.3215 19.25 14.4375C19.25 14.5535 19.2039 14.6648 19.1219 14.7469C19.0398 14.8289 18.9285 14.875 18.8125 14.875H13.5625C13.4465 14.875 13.3352 14.8289 13.2531 14.7469C13.1711 14.6648 13.125 14.5535 13.125 14.4375V7.4375C13.125 7.32147 13.1711 7.21019 13.2531 7.12814C13.3352 7.04609 13.4465 7 13.5625 7Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgHistory;